import React from "react";
import { last } from "ramda";
import PropTypes from "prop-types";
import pluralize from "pluralize";
import { Typography } from "@mui/material";

import useStyles from "./useStyles";

const Details = ({ name, castOptions }) => {
  const classes = useStyles();

  const formatCastOptions = (castNumOptions) => {
    const lastOption = last(castNumOptions);
    const firstOption = castNumOptions[0];
    if (lastOption !== firstOption) return `${firstOption} to ${lastOption} People`;
    return `${firstOption} ${pluralize("Person", firstOption)}`;
  };

  return (
    <>
      <Typography variant="small" className={classes.title}>
        {name}
      </Typography>
      <Typography variant="small" className={classes.options}>
        Cast {formatCastOptions(castOptions)}
      </Typography>
    </>
  );
};

Details.propTypes = {
  name: PropTypes.string,
  castOptions: PropTypes.arrayOf(PropTypes.number),
};

export default Details;
